import {
  Button,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_CMS_TVCHANNELS,
} from '../../../../../constants/RoleConsts';
import {
  TVCHANNEL_CATEGORY_CREATE,
  TVCHANNEL_CATEGORY_EDIT,
} from '../../../../../constants/TvChannelsConst';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import AssignCategoryPopupModel from '../../../../../shared/assign-category-popup/Assign-Category-Popup';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import CustomPopupModel from '../../../../../shared/custom-popup/Custom-Popup';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import {
  assignNewCategory,
  deleteCategoryDetails,
  updateCategoryDetails,
  uploadBulkCategoriesByCSV,
} from '../../../../../utils/cmsUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {
  categoryChannelSelector,
  categorySelector,
  channelNumberSelector,
  fetchAllCategoryChannels,
  fetchAllCategorys,
  fetchAllChannels,
  fetchChannelNumberList,
  setCategoryChannelsSuccess,
  setCategorysSuccess,
} from '../../../cmsSlice';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { createDataSortMapping } from '../../../../../utils/PropertyAPIUtils';
import { Dialog } from '@mui/material';
import CsvUploader from '../../../../../shared/csv-uploader/Csv-Uploader';
import { validateAlphanumeric } from '../../../../../utils/formUtils';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { DOWNLOAD_ASSETS_URL } from '../../../../../env/Configurations';

const CategoryList = (props) => {
  const {
    onDrawerToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;
  const categoryList = useSelector(categorySelector);
  const categoryChannels = useSelector(categoryChannelSelector);
  const [category, setCategory] = useState([]);
  const [channels, setChannels] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [loading, setLoading] = useState(true);
  const channelList = useSelector(channelNumberSelector);
  const [channelListNum, setChannelListNum] = useState(null);
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    type: 'delete',
    description: '',
    status: false,
    anchorEl: null,
    category: null,
  });
  const dispatch = useDispatch();
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [nestedStatus, setNestedStatus] = useState(false);
  const [searchText, setSearchText] = useState('');
  const dragDisabled = !!searchText || category?.length <= 1;
  const nestedDragDisabled = !!searchText || channels?.length <= 1;
  const [uploadState, setUploadState] = useState(false);
  const [csvUploadStatus, setCsvUploadStatus] = useState(false);
  const [csvUploadErrorMsg, setCsvUploadErrorMsg] = useState(null);
  const [csvValidateError, setCsvValidateError] = useState(false);
  const [dataExistError, setDataExistError] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);

  useEffect(() => {
    setCategory(categoryList);
    setLoading(false);
    setSearchText('');
  }, [categoryList]);

  useEffect(() => {
    setChannels(categoryChannels);
  }, [categoryChannels]);

  useEffect(() => {
    setChannelListNum(channelList);
  }, [channelList]);

  useEffect(() => {
    if (loading || category?.length === 0) return;
    const totalItems = category?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [category?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const handleSearchText = async (searchText) => {
    setSearchText(searchText);
    const filteredRows = await categoryList.filter((item) => {
      return (
        item.name.toLowerCase().includes(searchText.toLowerCase()) ||
        item.code.toLowerCase().includes(searchText.toLowerCase())
      );
    });
    onsetPage(0);
    setCategory(filteredRows);
  };

  const handleCellMenuClick = (event, category) => {
    event.stopPropagation();
    setSelectedValue({
      id: category.id,
      name: category.name,
      title: '',
      description: '',
      type: 'delete',
      status: false,
      anchorEl: event.currentTarget,
      category: category,
    });
  };

  const onClickDeactivate = async (event, payload) => {
    event.stopPropagation();
    const item = { ...payload };
    item.status = !payload.isActive;
    await updateCategoryDetails(item, selectedHotel);
    notificationManager(
      'success',
      payload.isActive ? 'Category deactivated successfully' : 'Category activated successfully',
    );
    dispatch(fetchAllCategorys(selectedHotel));
    handleClose();
  };

  const onOpenDrawer = (event, type) => {
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.category);
    handleClose();
  };

  const deleteCategory = async (e, item) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete ',
      description: 'This action cannot be reversed.',
      status: true,
      anchorEl: null,
    }));
  };

  const reAssignCategory = () => {
    setSelectedValue((prev) => ({
      ...prev,
      type: 'reassignConfirm',
      status: true,
      anchorEl: null,
    }));
  };

  const deleteCategoryAPICall = async (e) => {
    const channelCount = channelListNum[selectedValue.category.id] || 0;
    try {
      if (selectedHotel && selectedValue && selectedValue.id) {
        const lang = decryptLocalStorage('lang');
        const selectedLang = lang !== 'en' ? lang : '';
        if (channelCount === 0) {
          await deleteCategoryDetails(selectedValue.id, selectedHotel, selectedLang);
          dispatch(fetchAllCategorys(selectedHotel));
          notificationManager('success', 'Category deleted successfully');
          handleClose();
        } else {
          setSelectedValue((prev) => ({
            ...prev,
            title: 'Unable to delete ',
            type: 'reassign',
            description:
              'The selected category has (' +
              channelCount +
              ') Channels assigned to it. Please reassign these channels to delete the selected category.',
            status: true,
            anchorEl: null,
            buttonName: 'Reassign',
          }));
        }
      }
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Category');
      }
      handleClose();
    }
  };

  const reAssignCategoryAPICall = async (newCategoryId, newCategoryName) => {
    try {
      if (selectedHotel && selectedValue && selectedValue.id) {
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        await assignNewCategory(
          newCategoryId,
          selectedValue.id,
          selectedHotel,
          newCategoryName,
          selectedValue.name,
          language,
        );
        dispatch(fetchAllCategorys(selectedHotel));
        dispatch(fetchChannelNumberList(selectedHotel));
        dispatch(fetchAllChannels(selectedHotel));
        notificationManager('success', 'Reassigned ');
        handleClose();
      }
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to Reassign');
      }
      handleClose();
    }
  };

  const onCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      type: 'delete',
      description: '',
      status: false,
      anchorEl: null,
    });
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      type: 'delete',
      description: '',
      status: false,
      anchorEl: null,
      category: null,
    });
  };

  const onCategoryExpand = async (e, id) => {
    if (expanded.includes(id)) {
      setExpanded([]);
    } else {
      dispatch(fetchAllCategoryChannels(selectedHotel, id));
      setExpanded([id]);
    }
  };

  const onClickUpload = (e) => {
    setUploadState(true);
  };

  const handleUploadDialogClose = (e) => {
    dispatch(fetchAllCategorys(selectedHotel));
    setCsvUploadStatus(null);
    setUploadState(false);
  };

  const handleCsvFileData = (itemsList) => {
    const isTemplateInstructionRow = (row) => {
      const values = Object.values(row).map((v) => String(v || '').toLowerCase().trim());
      const joined = values.join(' ');
      const instructionPatterns = [
        'character limit', 'mandatory', 'alphanumeric', 'alpha-numeric',
        'enter the', 'fill in', 'e.g.', 'example:', 'max characters',
        'max char', 'required field', 'this field', 'drop down', 'dropdown',
        'select from', 'free text', 'auto populate', 'auto-populate',
      ];
      if (values.some((s) => s.startsWith('*') && instructionPatterns.some((p) => s.includes(p)))) return true;
      if (instructionPatterns.filter((p) => joined.includes(p)).length >= 2) return true;
      return false;
    };
    const filteredItemList = itemsList.filter((row) => !isTemplateInstructionRow(row));
    if (filteredItemList.length === 0) {
      setValidationErrors(['No data rows found in the uploaded file.']);
      setCsvValidateError(true);
      return;
    }

    const databaseNames = new Set((categoryList || []).map((b) => b?.name?.trim()?.toLowerCase()).filter(Boolean));
    const databaseCodes = new Set((categoryList || []).map((b) => b?.code?.trim()?.toLowerCase()).filter(Boolean));

    const nameFreq = Object.create(null);
    const codeFreq = Object.create(null);
    filteredItemList.forEach((item) => {
      const nK = (item?.categoryName || '').trim().toLowerCase();
      const cK = (item?.categoryCode || '').trim().toLowerCase();
      if (nK) nameFreq[nK] = (nameFreq[nK] || 0) + 1;
      if (cK) codeFreq[cK] = (codeFreq[cK] || 0) + 1;
    });

    const fileDupNames = new Set(Object.keys(nameFreq).filter(k => nameFreq[k] > 1));
    const fileDupCodes = new Set(Object.keys(codeFreq).filter(k => codeFreq[k] > 1));

    const errors = [];
    const newItems = [];
    filteredItemList.forEach((item) => {
      const rowNum = item.__rowNum || '?';
      const rowErrors = [];

      const catName = (item?.categoryName || '').trim();
      const catCode = (item?.categoryCode || '').trim();
      if (!catName) {
        rowErrors.push('"Category Name" is empty');
      } else if (catName.length > 100) {
        rowErrors.push('"Category Name" exceeds 100 characters');
      }
      if (!catCode) {
        rowErrors.push('"Category Code" is empty');
      } else if (catCode.length > 50) {
        rowErrors.push('"Category Code" exceeds 50 characters');
      }

      const isValidStatus = (status) => {
        const tempStatus = (status || '').toString().toLowerCase().trim();
        return tempStatus === 'yes' || tempStatus === 'no';
      };

      if (item.active?.trim() && !isValidStatus(item.active)) {
        rowErrors.push('"Active" must be Yes or No');
      }

      const nK = catName.toLowerCase();
      const cK = catCode.toLowerCase();
      const nameExists = nK && (databaseNames.has(nK) || fileDupNames.has(nK));
      const codeExists = cK && (databaseCodes.has(cK) || fileDupCodes.has(cK));

      if (nameExists || codeExists) {
        const reasons = [];
        if (nameExists) reasons.push(`name '${catName}'`);
        if (codeExists) reasons.push(`code '${catCode}'`);
        rowErrors.push(`Already exists or duplicated in file (${reasons.join(' and ')})`);
      }

      if (rowErrors.length > 0) {
        errors.push(`Row ${rowNum}: ${rowErrors.join(', ')}`);
      } else {
        newItems.push(item);
      }
    });

    if (errors.length > 0) {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
      return;
    }

    if (newItems.length > 0) {
      const listToUpload = newItems?.map((item) => {
        return {
          name: item?.categoryName?.trim(),
          code: item?.categoryCode?.trim(),
          hotelId: selectedHotel,
          isActive: item?.active?.trim()?.toUpperCase() === 'YES',
        };
      });
      setValidationErrors([]);
      setCsvValidateError(false);
      handleCsvDataSubmit(false, listToUpload);
    } else {
      setValidationErrors(errors);
      setCsvValidateError(true);
      setDataExistError(false);
    }
  };

  const handleCsvDataSubmit = async (isReplacing, payloadLists) => {
    setCsvUploadStatus('uploading');

    try {
      const payload = {
        isReplace: isReplacing,
        hotelId: selectedHotel,
        categories: payloadLists,
      };
      const selectedLanguage = decryptLocalStorage('lang');
      const language = selectedLanguage !== 'en' ? selectedLanguage : '';
      const res = await uploadBulkCategoriesByCSV(payload, language);
      if (res?.data?.uploadCategoriesByCSV?.status === 'Success') {
        setCsvUploadStatus('success');
      } else {
        setCsvUploadStatus('error');
      }
    } catch (e) {
      setCsvUploadStatus('server-error');
    }
  };
  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const generateExportData = (category) => {
    const fields = ['name', 'code'];
    return category.map((record) =>
      Object.fromEntries(
        Object?.entries(record)?.filter(([key, value]) =>
          fields?.includes(key) ? [key, "'" + value] : null,
        ),
      ),
    );
  };

  const generateHeaders = [
    { label: 'Category Name', key: 'name' },
    { label: 'Category Code', key: 'code' },
  ];

  return (
    <div className='mt-4 mb-4 group-list-container'>
      <Dialog fullScreen open={uploadState} onClose={handleUploadDialogClose}>
        <CsvUploader
          onClose={handleUploadDialogClose}
          pageTitle='Category Info'
          onFileReadingComplete={(e) => handleCsvFileData(e)}
          csvUploadStatus={csvUploadStatus}
          validFormatError={csvValidateError}
          setValidFormatError={setCsvValidateError}
          dataExistError={dataExistError}
          setDataExistError={setDataExistError}
          listName='Categories'
          sectionTItle='TV Channels'
          csvUploadErrorMsg={csvUploadErrorMsg}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
          downloadLink={DOWNLOAD_ASSETS_URL + '/cmsAssets/TV_Channel_Category_Template.xlsx'}
        />
      </Dialog>
      {selectedValue.id && selectedValue.type === 'delete' && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteCategoryAPICall}
          onDeleteCancel={onCancel}
        />
      )}
      {selectedValue.id && selectedValue.type === 'reassign' && selectedValue.status === true && (
        <CustomPopupModel
          popUp={selectedValue}
          onClick={reAssignCategory}
          onClickCancel={onCancel}
        />
      )}
      {selectedValue.id &&
        selectedValue.type === 'reassignConfirm' &&
        selectedValue.status === true && (
          <AssignCategoryPopupModel
            data={selectedValue}
            onConfirm={reAssignCategoryAPICall}
            onClickCancel={onCancel}
            listCategory={categoryList}
          />
        )}
      <div className='row mx-2 d-flex'>
        <SearchBar
          type={TVCHANNEL_CATEGORY_CREATE}
          buttonName='Add Category'
          onOpenDrawer={onOpenDrawer}
          displayAddOrEdit={
            permissions[RBAC_TYPE_CMS_TVCHANNELS] === RBAC_PERMISSION_LEVEL_FULL_ACCESS
              ? 'show'
              : 'hide'
          }
          setSearchText={handleSearchText}
          visible={visible}
          setVisible={setVisible}
          popUp={popUp}
          setPopUp={setPopUp}
          placeHolder={nestedStatus ? channels : category}
          setPlaceHolder={nestedStatus ? setChannels : setCategory}
          globalPlaceHolder={nestedStatus ? categoryChannels : categoryList}
          setGlobalPlaceHolder={nestedStatus ? setCategoryChannelsSuccess : setCategorysSuccess}
          dispatch={dispatch}
          mappingApi={createDataSortMapping}
          displayText={nestedStatus ? 'TV category channels' : 'TV category'}
          module={nestedStatus ? 'TV_CATEGORY_CHANNEL' : 'TV_CATEGORY'}
          nestedStatus={nestedStatus}
          setNestedStatus={setNestedStatus}
          setExpanded={setExpanded}
          searchText={searchText}
          setSearch={setSearchText}
          extraSecondaryBtnDisplay={true}
          extraSecondaryBtnText='Upload'
          onClickSecondaryBtn={onClickUpload}
          exportBtn
          exportBtnTitle='Export'
          exportData={generateExportData(category)}
          headers={generateHeaders}
          actionMenuItems={[]}
        />
      </div>
      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          category && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell className='w-35'>Name</TableCell>
                    <TableCell className='w-25'>Code</TableCell>
                    <TableCell className='w-25' align='center'>
                      No of Channels
                    </TableCell>
                    <TableCell className='w-20' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>

                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      category,
                      setCategory,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='category' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? category.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : category
                        ).map((categoryItem, i) => (
                          <Draggable
                            key={categoryItem?.id}
                            draggableId={categoryItem?.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <>
                                <TableRow
                                  className='border-white pointer'
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <TableCell>
                                    {!dragDisabled && (
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    )}
                                  </TableCell>
                                  <TableCell className='w-35'>{categoryItem?.name}</TableCell>
                                  <TableCell className='w-25'>{categoryItem?.code}</TableCell>
                                  <TableCell className='w-25' align='center'>
                                    {!channelListNum[categoryItem?.id]
                                      ? '0'
                                      : channelListNum[categoryItem?.id]}
                                  </TableCell>
                                  <TableCell className='w-20' align='center'>
                                    <div className='d-flex justify-content-center'>
                                      <div
                                        className={`${
                                          categoryItem?.isActive ? 'pill-active ' : 'pill-inactive '
                                        } pill d-flex justify-content-center align-items-center`}
                                      >
                                        <span className='ms-1'>
                                          {!categoryItem?.isActive ? 'Inactive' : 'Active'}
                                        </span>
                                      </div>
                                    </div>
                                  </TableCell>
                                  <TableCell align='right'>
                                    {permissions[RBAC_TYPE_CMS_TVCHANNELS] ===
                                      RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                      <Button
                                        aria-controls='simple-menu'
                                        aria-haspopup='true'
                                        onClick={(e) => {
                                          handleCellMenuClick(e, categoryItem);
                                        }}
                                        className='showpopupInner'
                                      >
                                        <MoreHoriz className='showpopupInner' />
                                      </Button>
                                    )}
                                    <div>
                                      <Menu
                                        id={i}
                                        anchorEl={selectedValue?.anchorEl}
                                        disableRestoreFocus
                                        MenuListProps={{ autoFocusItem: false }}
                                        keepMounted
                                        open={
                                          Boolean(selectedValue.anchorEl) &&
                                          selectedValue.id === categoryItem.id
                                        }
                                        onClose={handleClose}
                                        className='shadow'
                                      >
                                        <MenuItem
                                          className='pe-4'
                                          onClick={(e) => {
                                            onClickDeactivate(e, selectedValue.category);
                                          }}
                                        >
                                          {selectedValue.category?.isActive ? (
                                            <>
                                              <RemoveCircle className='me-2 action-menu-icon' />
                                              Deactivate
                                            </>
                                          ) : (
                                            <>
                                              <AddCircle className='me-2 action-menu-icon' />
                                              Activate
                                            </>
                                          )}
                                        </MenuItem>
                                        <MenuItem
                                          className='pe-4'
                                          onClick={(e) => {
                                            onOpenDrawer(e, TVCHANNEL_CATEGORY_EDIT);
                                          }}
                                        >
                                          <CreateIcon className='me-2 action-menu-icon' />
                                          Edit
                                        </MenuItem>
                                        <MenuItem
                                          className='pe-4'
                                          onClick={(e) => {
                                            deleteCategory(e, selectedValue.category);
                                          }}
                                        >
                                          <DeleteForeverIcon className='me-2 action-menu-icon' />
                                          Delete
                                        </MenuItem>
                                      </Menu>
                                    </div>
                                  </TableCell>
                                  <TableCell>
                                    <div
                                      className='col-md-1'
                                      onClick={(e) => {
                                        onCategoryExpand(e, categoryItem.id);
                                      }}
                                    >
                                      {expanded.includes(categoryItem.id) ? (
                                        <ExpandLessIcon className='showpopupInner' />
                                      ) : (
                                        <ExpandMoreIcon className='showpopupInner' />
                                      )}
                                    </div>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      paddingBottom: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                    }}
                                    colSpan={8}
                                  >
                                    <Table>
                                      <DragDropContext
                                        onDragEnd={(event) => {
                                          handleOnDragEnd(event, setVisible, channels, setChannels);
                                          setNestedStatus(true);
                                        }}
                                        isDropDisabled={nestedDragDisabled}
                                      >
                                        <Droppable droppableId='channels'>
                                          {(provided) => (
                                            <TableBody
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {expanded?.includes(categoryItem?.id) &&
                                                channels?.map((channel, j) => (
                                                  <Draggable
                                                    key={channel.id}
                                                    draggableId={channel.id}
                                                    index={j}
                                                    isDragDisabled={nestedDragDisabled}
                                                  >
                                                    {(provided) => (
                                                      <TableRow
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        className='border-white pointer'
                                                      >
                                                        <TableCell
                                                          style={{
                                                            width: '1rem',
                                                          }}
                                                        >
                                                          {!nestedDragDisabled && (
                                                            <DragIndicator className='res-menu-accordion-drag' />
                                                          )}
                                                        </TableCell>
                                                        <TableCell className='w-25' align='left'>
                                                          <span className='gray-text'>
                                                            Channel Number :{' '}
                                                          </span>
                                                          {channel.number}
                                                        </TableCell>
                                                        <TableCell className='w-25'>
                                                          <span className='gray-text'>
                                                            Channel :{' '}
                                                          </span>
                                                          {channel.name}
                                                        </TableCell>
                                                        <TableCell className='w-15' align='center'>
                                                          <span className='gray-text'>
                                                            Language :{' '}
                                                          </span>
                                                          {channel.language}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                          <div className='d-flex justify-content-center'>
                                                            <div
                                                              className={`${
                                                                channel.status
                                                                  ? 'pill-active '
                                                                  : 'pill-inactive '
                                                              } pill d-flex justify-content-center align-items-center`}
                                                            >
                                                              <span className='ms-1'>
                                                                {!channel.status
                                                                  ? 'Inactive'
                                                                  : 'Active'}
                                                              </span>
                                                            </div>
                                                          </div>
                                                        </TableCell>
                                                        <TableCell></TableCell>
                                                        <TableCell></TableCell>
                                                      </TableRow>
                                                    )}
                                                  </Draggable>
                                                ))}
                                              {provided.placeholder}
                                            </TableBody>
                                          )}
                                        </Droppable>
                                      </DragDropContext>
                                    </Table>
                                  </TableCell>
                                </TableRow>
                              </>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={category.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
      </div>
    </div>
  );
};

export default CategoryList;
